import debounce from 'lodash/debounce';
import { useEffect, useRef, useCallback } from 'react';

export function useDebounce<ReturnType>(fn: () => ReturnType, wait: number) {
  const waiting = useRef(false);

  const wrappedFn = useCallback(() => {
    waiting.current = false;
    fn();
  }, [fn]);

  const debouncedFn = useRef(debounce(wrappedFn, wait));

  // If hook arguments changed, cancel any queued function call and recreate the
  // debouncedFn
  useEffect(() => {
    debouncedFn.current.cancel();
    debouncedFn.current = debounce(wrappedFn, wait);

    if (waiting.current) {
      debouncedFn.current();
    }
  }, [wrappedFn, wait]);

  return () => {
    waiting.current = true;
    debouncedFn.current();
  };
}
